// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuTracker_root__2-zdz","wrapper":"MenuTracker_wrapper__2lg4R","title":"MenuTracker_title__7utCF"};